module.exports = __webpack_public_path__ + "static/media/aboutclass.0fd951e3.png";